/** @format */

import { useState } from "react";
import DataTable from "react-data-table-component";
import { Badge, Button } from "reactstrap";
import FilterComponent from "../../Components/Applications/ECommerce/Common/FilterComponent";
import { useSelector } from "react-redux";
import { getFormattedPrice } from "../../services/helper";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setLoading } from "../../ReduxToolkit/Reducers/AppReducer";
import { closeRegister } from "../../ReduxToolkit/Reducers/CartReducer";
import { FaTimes } from "react-icons/fa";
import Loader from "../../Layout/Loader";
import { openViewWithParams } from "../../ReduxToolkit/Reducers/viewReducer";
import Swal from "sweetalert2";

export default function ListTable() {
  const [modalOpen, setModalOpen] = useState(false);
  const [filterText, setFilterText] = useState("");
  const { registers, isLoading } = useSelector((state) => state.app);
  const dispatch = useDispatch();

  const handleCloseRegister = async (register) => {
    const result = await Swal.fire({
      title: "Close Register?",
      text: "When this register is closed, a new register will be opened automatically.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, close it",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        dispatch(setLoading(true));
        await dispatch(
          closeRegister({
            register_id: register.id,
          })
        ).unwrap();
        toast.success("Register closed successfully.");
        setModalOpen(false);
      } catch (e) {
        console.error("Close register error:", e);
        toast.error(e || "Failed to close register");
      } finally {
        dispatch(setLoading(false));
      }
    }
  };

  const categoryColumns = [
    {
      name: "ID",
      selector: (row) => row?.id,
      sortable: true,
      cell: (row) => <p>{row?.id}</p>,
      width: "10%", // Increased to 10% for better spacing
    },
    {
      name: "Title",
      selector: (row) => row?.title,
      sortable: true,
      cell: (row) => <p>{row?.title}</p>,
      width: "35%", // Adjusted to 35%
    },
    {
      name: "Opening Amnt",
      selector: (row) => row?.initial_cash,
      sortable: true,
      cell: (row) => <p>{getFormattedPrice(row?.initial_cash)}</p>,
      width: "15%", // Slightly increased
    },
    {
      name: "Closing Amnt",
      selector: (row) => row?.total_amount,
      sortable: true,
      cell: (row) => {
        return row.status !== "closed" ? (
          "--"
        ) : (
          <p>{getFormattedPrice(row?.total_amount)}</p>
        );
      },
      width: "15%", // Adjusted for consistency
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="d-flex gap-2">
          {row?.status === "open" ? (
            <Button color="danger" onClick={() => handleCloseRegister(row)}>
              <FaTimes /> Close
            </Button>
          ) : (
            <Badge color="info">Closed</Badge>
          )}
        </div>
      ),
      width: "25%",
      center: true,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const filteredItems = registers.filter((item) => {
    return Object.values(item).some(
      (value) =>
        value &&
        value.toString().toLowerCase().includes(filterText.toLowerCase())
    );
  });

  return (
    <div className="list-product list-category">
      {isLoading && <Loader />}
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        filterText={filterText}
      />
      {filteredItems.length > 0 ? (
        <DataTable
          className="custom-scrollbar"
          data={filteredItems}
          columns={categoryColumns}
          pagination
          onRowClicked={(row) =>
            dispatch(
              openViewWithParams({
                view: "close_register_summary",
                params: { register_id: row.id, backTo: "registers" },
              })
            )
          }
          pointerOnHover
        />
      ) : (
        <p>No registers found.</p>
      )}
    </div>
  );
}
